export default __webpack_public_path__ + "images/TR.c50aeda.png";